import Phaser from 'phaser';
import Background, {
  preload as preloadBackground,
} from '../objects/background';
import Ornament, { preload as preloadOrnament } from '../objects/ornament';
import CostumeSet, {
  MODELS,
  preload as preloadCostumes,
} from '../objects/costume';
import { preload as preloadAudio } from '../objects/audio';
import { getAssetsUrl } from 'utilities';

import EVENTS from 'constants/EVENTS';
import { 
  landbotHeight,
  groundHeight,
  supportBarHeight,
} from '../definitions';
import { fourthPositions, fadeOutSound } from '../utils';

/**
 * Act 1 - Select your Costume.
 */
export default class Act1 extends Phaser.Scene {
  constructor() {
    super({ key: 'Act1', active: true });
  }

  preload() {
    this.load.setBaseURL(getAssetsUrl());

    preloadBackground.call(this, 'wall', 'brick_pattern.png');
    preloadBackground.call(this, 'ground', 'ground.png');
    preloadOrnament.call(this, 'spider_web', 'spider_web.png');
    preloadOrnament.call(this, 'spiders', 'spiders.png');

    preloadAudio.call(this, 'music', 'music.mp3');
    preloadAudio.call(this, 'storm', 'storm_wind.mp3');
    preloadCostumes.call(this);
  }

  create() {
    this.cameras.main.setBackgroundColor('#10101C');
    this.cameras.main.fadeIn(2000);
    this.time.delayedCall(2000, () => {
      __landbot.events.emit(EVENTS.SET_VISIBLE, true);
    });

    // GAME OBJECTS

    this.wall = new Background(
      this,
      0,
      this.game.config.height,
      this.game.config.width,
      this.game.config.height,
      'wall'
    );

    this.ground = new Background(
      this,
      0,
      this.game.config.height - landbotHeight,
      this.game.config.width,
      groundHeight,
      'ground'
    );

    this.support_bar = new Background(
      this,
      0,
      this.game.config.height - landbotHeight - groundHeight - supportBarHeight,
      this.game.config.width,
      12,
      'ground'
    );

    const web_left = new Ornament(this, 0, 0, 'spider_web');
    web_left.setOrigin(0, 0);
    web_left.setScale(0.6);

    const spiders = new Ornament(this, 250, -200, 'spiders');
    spiders.setOrigin(0, 0);
    spiders.setScale(0.5);
    this.tweens.add({
      targets: spiders,
      duration: 2000,
      delay: 4000,
      ease: Phaser.Math.Easing.Cubic.Out,
      y: 0,
    });

    const web_right = new Ornament(
      this,
      this.game.config.width,
      0,
      'spider_web'
    );
    web_right.setOrigin(1, 0);
    web_right.setScale(0.6);
    web_right.setFlipX(true);

    const costumeFourthPositions = fourthPositions(this.game.config.width);
    this.mummyCostume = new CostumeSet(
      this,
      costumeFourthPositions[0],
      this.support_bar.y - 20,
      MODELS.MUMMY
    );
    this.skeletonCostume = new CostumeSet(
      this,
      costumeFourthPositions[1],
      this.support_bar.y - 20,
      MODELS.SKELETON
    );
    this.frankieCostume = new CostumeSet(
      this,
      costumeFourthPositions[2],
      this.support_bar.y - 20,
      MODELS.FRANKIE
    );
    this.zombieCostume = new CostumeSet(
      this,
      costumeFourthPositions[3],
      this.support_bar.y - 20,
      MODELS.ZOMBIE
    );

    this.audio = {
      storm: this.sound.add('storm', {
        volume: 0.3,
        loop: true,
      }),
      // background: this.sound.add('music', {
      //   volume: 0.3,
      //   loop: true,
      // }),
    };

    // PHYSICS

    this.physics.add.existing(this.ground);
    this.ground.body.setSize(this.game.config.width, groundHeight);
    this.ground.body.setAllowGravity(false);
    this.ground.body.immovable = true;

    // SCRIPT

    this.audio.storm.play();
    // this.audio.background.play();

    __landbot.events.on(EVENTS.ACT_1_ENDING, () => {
      __landbot.events.emit(EVENTS.SET_VISIBLE, false);
      this.cameras.main.fadeOut(1500);
      fadeOutSound.call(this, this.audio.storm, 1500);
      this.time.delayedCall(1500, () => {
        __landbot.events.emit(EVENTS.ACT_2);
        this.scene.start('Act2', {
          costume: this.data.get('costume'),
        });
      });
    });

    __landbot.events.on('select_costume', (model) => {
      selectCostume.call(this, model);
      this.data.set('costume', model);
    });
  }
}

function selectCostume(model) {
  [
    this.mummyCostume,
    this.skeletonCostume,
    this.frankieCostume,
    this.zombieCostume,
  ]
    .filter((costume) => costume.MODEL !== model)
    .forEach((costume) => costume.fade());
}
